import React from 'react';
import { motion } from 'framer-motion';

const SceneContent = ({ scene, isFirst, hideContent = false }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 1.0,
        delayChildren: isFirst ? 1 : 0.5,
      }
    }
  };

  const lineVariants = {
    hidden: { 
      opacity: 0, 
      y: 12 
    },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 2,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };

  const dividerVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: {
        delay: scene.lines.filter(l => l !== '').length * 1.0 + 2,
        duration: 1.5,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate={hideContent ? { opacity: 0 } : "visible"}
      transition={hideContent ? { duration: 2, ease: [0.25, 0.1, 0.25, 1] } : undefined}
      className="text-center"
    >
      {/* Scene lines */}
      <div className="space-y-5">
        {scene.lines.map((line, index) => {
          // Check for empty line - creates visual pause
          if (line === '' || line.trim() === '') {
            return <div key={index} className="h-3" />;
          }
          
          return (
            <motion.p
              key={index}
              variants={lineVariants}
              className="vaulten-body text-2xl sm:text-3xl md:text-4xl lg:text-5xl"
            >
              {line}
            </motion.p>
          );
        })}
      </div>

      {/* Divider - Unicode em dash or decorative element */}
      {/* Hide on path choice scene to avoid visual clutter */}
      {!scene.isPathChoice && (
        <motion.div
          variants={dividerVariants}
          className="mt-14 vaulten-divider"
        >
          ⸻
        </motion.div>
      )}
    </motion.div>
  );
};

export default SceneContent;
